import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import AppLayout from '@/components/feature/AppLayout';
import ProtectedRoute from '@/components/feature/ProtectedRoute';
import AdminRoute from '@/components/feature/AdminRoute';
import LoginPage from '@/pages/auth/LoginPage';
import SignupPage from '@/pages/auth/SignupPage';
import PendingPage from '@/pages/auth/PendingPage';
import DashboardPage from '@/pages/dashboard/page';
import StudentsPage from '@/pages/students/page';
import NewStudentPage from '@/pages/students/NewStudentPage';
import EditStudentPage from '@/pages/students/EditStudentPage';
import StudentDetailPage from '@/pages/students/StudentDetailPage';
import LessonsPage from '@/pages/lessons/page';
import TuitionPage from '@/pages/tuition/page';
import ExamsPage from '@/pages/exams/page';
import NewLessonPage from '@/pages/lessons/NewLessonPage';
import EditLessonPage from '@/pages/lessons/EditLessonPage';
import MembersPage from '@/pages/admin/MembersPage';
import ParentSharePage from '@/pages/share/ParentSharePage';
import SettingsPage from '@/pages/settings/SettingsPage';

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/pending',
    element: <PendingPage />,
  },
  {
    path: '/share/:token',
    element: <ParentSharePage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            path: '/',
            element: <DashboardPage />,
          },
          {
            path: '/students',
            element: <StudentsPage />,
          },
          {
            path: '/students/new',
            element: <NewStudentPage />,
          },
          {
            path: '/students/:id',
            element: <StudentDetailPage />,
          },
          {
            path: '/students/:id/edit',
            element: <EditStudentPage />,
          },
          {
            path: '/lessons',
            element: <LessonsPage />,
          },
          {
            path: '/tuition',
            element: <TuitionPage />,
          },
          {
            path: '/exams',
            element: <ExamsPage />,
          },
          {
            path: '/lessons/new',
            element: <NewLessonPage />,
          },
          {
            path: '/lessons/:id/edit',
            element: <EditLessonPage />,
          },
          {
            path: '/settings',
            element: <SettingsPage />,
          },
          {
            element: <AdminRoute />,
            children: [
              {
                path: '/admin/members',
                element: <MembersPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;